import { SkeletonLoading } from "@saleshandy/design-system";
import React from "react";

const AiCreditsLoader = () => {
  return (
    <div className="ai-credits-card">
      <div className="ai-credits-card-body">
        <div className="ai-credits-data aic-loader">
          <SkeletonLoading width={150} height={20} />
          <SkeletonLoading width={80} height={20} />
          <SkeletonLoading width={350} height={20} />
        </div>
        <SkeletonLoading width={150} height={32} />
      </div>
    </div>
  );
};

export default AiCreditsLoader;
